// extracted by mini-css-extract-plugin
module.exports = {"col-wrapper":"styles-module__col-wrapper___zISoW","email-template-input":"styles-module__email-template-input___KR0od"};